export default __webpack_public_path__ + "static/media/Nav-Hub.9b9c5b4a.svg";